import { BehaviorSubject, Observable } from 'rxjs';
// import { ModalWindowService } from 'src/app/services/ui/modal-window.service';
// import { HuginnErrorCodesEnum } from './../../utils/enums/error-codes/huginn-error-codes.enum';
import { Injectable, Output, EventEmitter } from '@angular/core';
import { CorrectionListApiService, ICorrectionListItem, ICorrectionList } from './correction-list-api.service';
// import { CommonMessageDialogComponent } from 'src/app/components/dialogs/common-message-dialog/common-message-dialog.component';

export interface ICorrectionListEvent {
  word: string;
  langCode: string;
}

@Injectable({
  providedIn: 'root'
})
export class CorrectionListService {
  @Output() wordAdded: EventEmitter<ICorrectionListEvent> = new EventEmitter();
  @Output() wordDeleted: EventEmitter<ICorrectionListEvent> = new EventEmitter();

  private isLoadingSubj: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  get isLoadingObservable(): Observable<boolean> {
    return this.isLoadingSubj.asObservable();
  }

  constructor(
    private readonly correctionListApi: CorrectionListApiService,
    // private readonly modalService: ModalWindowService,
  ) { }

  async addWordToList(word: string, langCode: string) {
    if (word && langCode) {
      try {
        this.isLoadingSubj.next(true);
        await this.correctionListApi.addWord(word, langCode);
        this.isLoadingSubj.next(false);
        this.wordAdded.emit({word, langCode});
      } catch (err) {
        this.isLoadingSubj.next(false);
        // if (err && (err.errorCode === HuginnErrorCodesEnum.OnlyOneWordIsAllowed || err.errorCode === HuginnErrorCodesEnum.WordIsTooLong)) {
        //   this.modalService.createModalWindow(
        //     CommonMessageDialogComponent, { messageKey: `HUGINN_ERRORS.${err.errorCode}` }
        //   );
        // }
      }
    }
  }

  async deleteWordFromList(item: ICorrectionListItem) {
    if (item) {
      try {
        this.isLoadingSubj.next(true);
        await this.correctionListApi.deleteWord(item.id, item.langCode);
        this.isLoadingSubj.next(false);
        this.wordDeleted.emit({word: item.word, langCode: item.langCode});
      } catch (err) {
        this.isLoadingSubj.next(false);
      }
    }
  }

  async getCorrectionList(langCode: string, skip: number, take: number): Promise<ICorrectionList | undefined>  {
    if (langCode && skip >= 0 && take >= 0) {
      try {
        this.isLoadingSubj.next(true);
        const result = await this.correctionListApi.getCorrectionList(langCode, skip, take);
        this.isLoadingSubj.next(false);
        return result;
      } catch (err) {
        this.isLoadingSubj.next(false);
      }
    }
  }
}
